/**
 * Cores das situações de agendamento, compartilhadas pelo calendário e pela consulta:
 * o mesmo agendamento tem a mesma cor nas duas telas.
 */
const SITUACOES_AGENDAMENTO = {
  1: { descricao: "Agendado", cor: "#0085c1", corTexto: "#ffffff", icone: "pi-calendar" },
  2: { descricao: "Atendimento realizado", cor: "#00752b", corTexto: "#ffffff", icone: "pi-thumbs-up" },
  3: { descricao: "Paciente ausente", cor: "#cbb000", corTexto: "#1f2937", icone: "pi-times" },
  4: { descricao: "Cancelado pelo paciente", cor: "#c32626", corTexto: "#ffffff", icone: "pi-ban" },
  5: { descricao: "Cancelado pelo profissional", cor: "#c32626", corTexto: "#ffffff", icone: "pi-ban" },
};

const SITUACAO_PADRAO = { cor: "#64748b", corTexto: "#ffffff", icone: "" };

const situacaoAgendamento = (id) => SITUACOES_AGENDAMENTO[id] || SITUACAO_PADRAO;

const corSituacaoAgendamento = (id) => situacaoAgendamento(id).cor;

export { SITUACOES_AGENDAMENTO, situacaoAgendamento, corSituacaoAgendamento };
